import { render, staticRenderFns } from "./guidelines2.vue?vue&type=template&id=b4a5b338&scoped=true&"
var script = {}
import style0 from "./guidelines2.vue?vue&type=style&index=0&id=b4a5b338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5b338",
  null
  
)

export default component.exports